import React from 'react'
import Filter from '../Filter'
import type { FetchKey } from '@app/src/api/fetchHooks'
import type { AssessmentTemplate } from '@app/src/types/resourceExplorer'
import type { IntlFormatters } from 'react-intl'
import type { FacetItem } from '../..'
import FilterSelect from '../FilterSelect'
import { Operators } from '../useFilters'
import AssessmentLevelFilters from './AssessmentLevelFilters'

interface AssessmentSelectorFilterProps {
  templates: AssessmentTemplate[]
  facetOptions: FacetItem[]
  formatMessage: IntlFormatters['formatMessage']
  prefix?: string
  fetchKey: FetchKey
  facetEndpoint: string
  hideTemplateNameFilter?: boolean
}

const AssessmentSelectorFilter: React.FC<AssessmentSelectorFilterProps> = ({
  templates,
  facetOptions,
  formatMessage,
  prefix,
  fetchKey,
  facetEndpoint,
  hideTemplateNameFilter,
}) => {
  const [selectedTemplate, setSelectedTemplate] = React.useState<AssessmentTemplate | undefined>(
    hideTemplateNameFilter ? templates[0] : undefined,
  )

  return (
    <>
      {!hideTemplateNameFilter && (
        <Filter
          operator={Operators.EqualTo}
          name={prefix ? `${prefix}.assessmentTemplate.id` : 'assessmentTemplate.id'}
        >
          {({ value, onChange }) => {
            const selected = templates.find(t => t.id === Number(value))
            setSelectedTemplate(selected)
            return (
              <FilterSelect
                size="small"
                multiple={false}
                options={facetOptions}
                onChange={value => onChange(value)}
                fieldLabel={formatMessage({ id: 'assessment.filter.name' })}
                value={value as string}
              />
            )
          }}
        </Filter>
      )}

      {selectedTemplate && (
        <AssessmentLevelFilters
          template={selectedTemplate}
          prefix={prefix}
          fetchKey={fetchKey}
          facetEndpoint={facetEndpoint}
          formatMessage={formatMessage}
        />
      )}
    </>
  )
}

export default AssessmentSelectorFilter
